module.exports = __webpack_public_path__ + "static/img/icon-enter-item4.0608c85.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-enter-item4.png
// module id = pPf1
// module chunks = 21